/*
 *
 * File JS per la pagina di Archivio Blog
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import archiveFilters from "components/archive-filters/archive-filters";
import archiveList from "components/archive-list/archive-list";
import categories from "components/categories/categories";
import sliderColTextImg from "components/slider-col-text-img/slider-col-text-img";
import cardColTextImg from "components/cards/card-col-text-img";
import cardNews from "components/cards/card-news";
//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./archive.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
archiveFilters();
categories();
sliderColTextImg();

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//
